module.exports = __webpack_public_path__ + "static/crowdfunding-fulfillment-b6319ebf0fe0876602a4e11b9c887b72.png";